import { Theme, makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
// eslint-disable-next-line
import React, { ReactNode } from 'react';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  inlineIcon: {
    marginRight: theme.spacing(2),
  },
  absoluteCentered: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

export type Props = {
  inline?: boolean;
  absoluteCentered?: boolean;
  loadingText?: string | ReactNode;
};

const Loader = ({
  inline,
  absoluteCentered,
  loadingText = 'Cargando...',
}: Props) => {
  const classes = useStyles();

  if (inline) {
    return (
      <Grid container alignItems="center">
        <CircularProgress
          color="primary"
          thickness={6}
          size={24}
          className={classes.inlineIcon}
        />
        <Typography variant="body1">{loadingText} </Typography>
      </Grid>
    );
  }

  return (
    <div
      className={cx(classes.root, {
        [classes.absoluteCentered]: absoluteCentered,
      })}
    >
      <CircularProgress color="primary" thickness={6} />
      {loadingText && (
        <Box marginTop={1}>
          <Typography variant="body1">{loadingText} </Typography>
        </Box>
      )}
    </div>
  );
};

export default Loader;
